export const contractsConstants = {
  GET_CONTRACTS_SUCCESS: 'GET_CONTRACTS_SUCCESS',
  // SAVE_CONTRACT_SUCCESS: 'SAVE_CONTRACT_SUCCESS',
  // APPROVE_CONTRACT_SUCCESS: 'APPROVE_CONTRACT_SUCCESS',
  // ADD_CONTRACT_SUCCESS: 'ADD_CONTRACT_SUCCESS',

  CHANGE_CONTRACT_SUCCESS: 'CHANGE_CONTRACT_SUCCESS',
  CHANGE_CONTRACT_FAILURE: 'CHANGE_CONTRACT_FAILURE',

  DELETE_CONTRACT_SUCCESS: 'DELETE_CONTRACT_SUCCESS',
};
